import { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";

export type IEpochStakeData = {
  epoch: number;
  unstakeEpochV1: number;
  unstakeEpochV2: number;
  stakedAmountV1: string;
  stakedAmountV2: string;
  unstakedAmountV1: string;
  unstakedAmountV2: string;
  intendedStakedAmount: string;
};

type IStakedAccount = {
  id: string;
  accountAddress: string;
  totalStakedAmount: string;
  intendedStakedAmount: string;
  epochStakeAmounts?: IEpochStakeData[];
};

const useSubgraphData = () => {
  const { account } = useContext(AuthContext);
  const [accountStakingData, setAccountStakingData] =
    useState<IStakedAccount>();
  const [vaultStakingData, setVaultStakingData] = useState<IStakedAccount>();
  const SUBGRAPH_URI = process.env.REACT_APP_AEVO_SUBGRAPH_URI || "";

  const fetchSubgraphData = useCallback(async () => {
    try {
      const accountAddresses = account
        ? `["${account.toLowerCase()}", "TOTAL_CONTRACT"]`
        : '["TOTAL_CONTRACT"]';

      const query = `
        {
            stakedAccounts(where: {accountAddress_in: ${accountAddresses}}) {
                id,
                accountAddress,
                totalStakedAmount,
                intendedStakedAmount,
                epochStakeAmounts {
                    stakedAmountV1,
                    stakedAmountV2,
                    intendedStakedAmount,
                    unstakedAmountV1,
                    unstakedAmountV2,
                    unstakeEpochV1,
                    unstakeEpochV2,
                    epoch
                }
            }
        }
    `;
      const response = await axios.post(SUBGRAPH_URI, {
        query,
      });

      const stakedAccounts = response.data.data
        .stakedAccounts as IStakedAccount[];

      const responseAccountData = account
        ? stakedAccounts.find(
            (stakedAccount: IStakedAccount) =>
              stakedAccount.accountAddress.toLowerCase() ===
              account.toLowerCase()
          )
        : undefined;

      const responseVaultData = stakedAccounts.find(
        (stakedAccount: IStakedAccount) =>
          stakedAccount.accountAddress === "TOTAL_CONTRACT"
      );

      setAccountStakingData(responseAccountData);
      setVaultStakingData(responseVaultData);
    } catch (error: any) {
      // do nothing
    }
  }, [SUBGRAPH_URI, account]);

  useEffect(() => {
    fetchSubgraphData();
  }, [fetchSubgraphData]);

  return {
    accountStakingData,
    vaultStakingData,
    fetchSubgraphData,
  };
};

export default useSubgraphData;
